import { createReducer, on } from '@ngrx/store';
import * as SnmpAlertActions from './actions';
import { SnmpAlertStoreData } from './model';

export const initialState: SnmpAlertStoreData = {
  loading: false,
  selectedSnmpAlertGuids: [],
  alertTypes: [],
  deviceTypes: [],
  snmpDeviceCustomProperty: []
};

export const smnpAlertDeviceReducer = createReducer(
  initialState,
  on(SnmpAlertActions.loadAlertingInfo, (state) => ({ ...state, loading: true })),
  on(SnmpAlertActions.loadSnmpDeviceTypes, (state) => ({ ...state, loading: true })),
  on(SnmpAlertActions.loadSnmpAlertTypes, (state) => ({ ...state, loading: true })),
  on(SnmpAlertActions.loadSnmpAlertCustomisation, (state) => ({ ...state, loading: true })),
  on(SnmpAlertActions.fullLoadComplete, (state, action) => ({
    ...state,
    deviceTypes: action.deviceTypes,
    alertTypes: action.alertTypes,
    loading: false
  })),
  on(SnmpAlertActions.setLoading, (state, action) => ({ ...state, loading: action.loading })),
  on(SnmpAlertActions.setSnmpAlertCustomisation, (state, action) => ({ ...state, selectedSnmpAlertGuids: action.data, loading: false })),
  on(SnmpAlertActions.setSnmpAlertTypes, (state, action) => ({ ...state, alertTypes: action.alertTypes, loading: false })),
  on(SnmpAlertActions.setSnmpDeviceTypes, (state, action) => ({ ...state, deviceTypes: action.deviceTypes, loading: false })),
  on(SnmpAlertActions.setCustomProperties, (state, action) => ({ ...state, snmpDeviceCustomProperty: action.snmpDeviceCustomProperty })),
  on(SnmpAlertActions.resetCustomProperties, (state) => ({ ...state, selectedSnmpAlertGuids: [], snmpDeviceCustomProperty: [] }))
);
